/**
 * @generated SignedSource<<c616a7d3008aa81dbb94ea38471f844f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LabeledSelectBox_labeledSelectBox$data = {
  readonly label: string | null | undefined;
  readonly selectbox: {
    readonly " $fragmentSpreads": FragmentRefs<"Selectbox_selectBox">;
  } | null | undefined;
  readonly " $fragmentType": "LabeledSelectBox_labeledSelectBox";
};
export type LabeledSelectBox_labeledSelectBox$key = {
  readonly " $data"?: LabeledSelectBox_labeledSelectBox$data;
  readonly " $fragmentSpreads": FragmentRefs<"LabeledSelectBox_labeledSelectBox">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LabeledSelectBox_labeledSelectBox",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SelectBox",
      "kind": "LinkedField",
      "name": "selectbox",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Selectbox_selectBox"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LabeledSelectBox",
  "abstractKey": null
};

(node as any).hash = "7f268c5bbd53d6663a7879f242d1aa38";

export default node;
